import { render, staticRenderFns } from "./CashMessage.vue?vue&type=template&id=5c8ea6b6&"
import script from "./CashMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./CashMessage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports